/**
 * @module lib/SmartConversionUtils
 */

import axios from 'axios';

import { SmartConversionKeys } from '../constants/SmartConversion';
import Logger from '../tools/Logger';

const log = Logger.child({ component: 'lib/SmartConversionUtils' });

export function getCurrentTrackingEvents(state) {
  return state.smartConversion.get(SmartConversionKeys.TRACKING_EVENTS_KEY);
}

function hitTrackingUrl(url) {
  axios({
    url,
  })
    .then(() => {
      log.info('SmartConversion: successfully hit tracking URL ' + url);
    })
    .catch(error => {
      log.error('SmartConversion: error hitting tracking URL; ' + error);
    });
}

export function hitTrackingUrls(urls) {
  urls.forEach(url => {
    hitTrackingUrl(url);
  });
}

export function isSmartConversionFlowActive(state) {
  return !getCurrentTrackingEvents(state).isEmpty();
}

export function getSmartConversionHaymakerUrl(state) {
  return state.smartConversion.get(SmartConversionKeys.HAYMAKER_URL_KEY);
}
